import * as React from 'react';

import { IntersectionTracker } from '@shared-ui/clickstream-analytics-context';

import { PropertyRateCalendar } from 'src/common/__generated__/api/types';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export interface RateCalendarFooterProps {
  legends: PropertyRateCalendar.legend[];
}

export function RateCalendarFooter(props: RateCalendarFooterProps) {
  const { legends } = props;

  if (!legends || !legends.length) {
    return null;
  }

  return (
    <IntersectionTracker referrerId="HOT.SR:RateCalendarImpression" linkName="Rate Calendar Impression">
      <UitkLayoutFlex>
        {legends.map((legend, index) => {
          const trendLowerCase = legend.trend.toLowerCase() as 'positive' | 'negative';

          return (
            <>
              <UitkLayoutFlexItem key={`legend-icon-${index}`}>
                <UitkSpacing className={`rate-calendar-footer ${trendLowerCase}`}>
                  <UitkIcon name={legend.symbol} theme={trendLowerCase} size={UitkIconSize.MEDIUM} />
                </UitkSpacing>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem key={`legend-label-${index}`}>
                <UitkSpacing padding={{ blockstart: 'one', inlinestart: 'one', inlineend: 'three' }}>
                  <UitkText weight={'bold'}>{legend.label}</UitkText>
                </UitkSpacing>
              </UitkLayoutFlexItem>
            </>
          );
        })}
      </UitkLayoutFlex>
    </IntersectionTracker>
  );
}
